// extracted by mini-css-extract-plugin
module.exports = {"container":"dashboard_container__1DctK","card":"dashboard_card__rZqWd"};